export function isCoarsePointer(): boolean {
  const mm =
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia("(pointer: coarse)").matches
      : false;
  const touch = typeof navigator !== "undefined" ? (navigator.maxTouchPoints || 0) > 0 : false;
  const narrow = typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  return mm || touch || narrow;
}
